export default __webpack_public_path__ + "static/media/Ballroll_00245.2cf143ec.png";